import { render, staticRenderFns } from "./SingleControl.vue?vue&type=template&id=bf006774&scoped=true&"
import script from "./SingleControl.vue?vue&type=script&lang=ts&"
export * from "./SingleControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf006774",
  null
  
)

export default component.exports